// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

body {
  background-color: black;
}

.banner-carousel {
  background: black;
}

.search-text {
  font-size: 16px;
  margin: 0px 8px 0px -1px;
  padding: 0px 13px;
  border-radius: 50px;
  color: grey;
}

.flaticon-search {
  color: white;
}

.error-msg {
  color: white;
}

.input-msg {
  display: inline-grid;
  font-size: 16px;
}

.inner-border {
  border-style: dashed;
  padding: 20px;
  border-color: #fff;
}

.owl-carousel {
  width: 100%;
  -webkit-tap-highlight-color: transparent;
  position: relative;
  z-index: 1;
}

.owl-carousel .owl-stage {
  position: relative;
  -ms-touch-action: pan-Y;
}

.owl-carousel .owl-stage:after {
  content: ".";
  display: block;
  clear: both;
  visibility: hidden;
  line-height: 0;
  height: 0;
}

.owl-carousel .owl-stage-outer {
  position: relative;
  overflow: hidden;
  -webkit-transform: translate3d(0px, 0px, 0px);
}

.owl-carousel .owl-item {
  position: relative;
  min-height: 1px;
  float: left;
  -webkit-backface-visibility: hidden;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
}

.owl-carousel .owl-item img {
  display: block;
  width: 100%;
  -webkit-transform-style: preserve-3d;
}

.owl-carousel .owl-nav.disabled,
.owl-carousel .owl-dots.disabled {
  display: none;
}

.owl-carousel .owl-nav .owl-prev,
.owl-carousel .owl-nav .owl-next,
.owl-carousel .owl-dot {
  cursor: pointer;
  cursor: hand;
  -webkit-user-select: none;
  user-select: none;
}

.owl-carousel.owl-loaded {
  display: block;
}

.owl-carousel.owl-loading {
  opacity: 0;
  display: block;
}

.owl-carousel.owl-hidden {
  opacity: 0;
}

.owl-carousel.owl-refresh .owl-item {
  visibility: hidden;
}

.owl-carousel.owl-drag .owl-item {
  -webkit-user-select: none;
  user-select: none;
}

.owl-carousel.owl-grab {
  cursor: move;
  cursor: grab;
}

.owl-carousel.owl-rtl {
  direction: rtl;
}

.owl-carousel.owl-rtl .owl-item {
  float: right;
}

.no-js .owl-carousel {
  display: block;
}

.owl-carousel .animated {
  animation-duration: 1000ms;
  animation-fill-mode: both;
}

.owl-carousel .owl-animated-in {
  z-index: 0;
}

.owl-carousel .owl-animated-out {
  z-index: 1;
}

.owl-carousel .fadeOut {
  animation-name: fadeOut;
}

@keyframes fadeOut {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}


.owl-height {
  transition: height 500ms ease-in-out;
}


.owl-carousel .owl-item .owl-lazy {
  opacity: 0;
  transition: opacity 400ms ease;
}

.owl-carousel .owl-item img.owl-lazy {
  transform-style: preserve-3d;
}

.owl-carousel .owl-video-wrapper {
  position: relative;
  height: 100%;
  background: #000;
}

.owl-carousel .owl-video-play-icon {
  position: absolute;
  height: 80px;
  width: 80px;
  left: 50%;
  top: 50%;
  margin-left: -40px;
  margin-top: -40px;

  cursor: pointer;
  z-index: 1;
  -webkit-backface-visibility: hidden;
  transition: transform 100ms ease;
}

.owl-carousel .owl-video-play-icon:hover {
  transform: scale(1.3, 1.3);
}

.owl-carousel .owl-video-playing .owl-video-tn,
.owl-carousel .owl-video-playing .owl-video-play-icon {
  display: none;
}

.owl-carousel .owl-video-tn {
  opacity: 0;
  height: 100%;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  transition: opacity 400ms ease;
}

.owl-carousel .owl-video-frame {
  position: relative;
  z-index: 1;
  height: 100%;
  width: 100%;
}

.previous,.next {
  background: #800925;
  color: #ffff;
  padding: 6px 6px;
  border-radius: 5px;
  width: 40px;
}
p.card-text {
  display: flex;
  flex-direction: column;
}

div.info-profile-one input::placeholder{
  color: #777777;
}

div.info-profile-one ul li{
  color: black;
}

/* div.edit-profile-data ul li input{
  border: 1px solid #00000042;
  padding: 2px 2px 0px 10px;
} */

div.edit-partner-data input{
  border: 1px solid #00000042;
   width: 100%;
    padding: 2px 2px 0px 10px;
}
.edit-profile-data select {
  border: 1px solid #00000042;
  max-width: 284px;
  width: 100%;
 
  background: none;
}
.profile-edit-two li, .profile-data-two li{
  display: flex;
  flex-direction: column;
}
.profile-edit-two input, .profile-edit-two select{
  border: 2px solid #00000042;
  padding: 0px 3px;
  margin-left: 4px;
  border-radius: 5px;
}
.profile-data-two input{
  padding: 0px 3px;
  margin-left: 4px;
  border-radius: 5px;
}
.profile-edit-two label , .profile-data-two label{
  font-size: 15px;
  text-transform: capitalize;
  font-weight: 500;

}
.profile-page-input label{
  font-size: 15px;
  text-transform: capitalize;
  font-weight: 500;
  white-space: nowrap;
}

.profile-page-input input{
  border: 2px solid #00000042;
  padding: 0px 3px;
  margin-left: 4px;
  border-radius: 5px;
}
.info-profile-data .profile-page-input input{
  padding: 0px 3px;
  margin-left: 4px;
  border-radius: 5px;
  border: none;
}
.info-height {
  min-height: 425px;
}
.ifo-bg {
  background: #800925;
  padding: 8px 12px;
  border-radius: 10px;
}
.ifo-bg  i {
  color: #fff;
}
.unread-msg{
  margin-left: 80px;
  border-radius: 50%;
  border: 1px solid gray;
  padding: 0px 5px;
  background-color: #00000033;
  color: white;
}

.backBtn {
  display: flex;
  align-items: center;
  padding: 12px;
}

.backBtn h5 {font-size: 15px;display: flex;align-items: center;}

.backBtn h5 svg {
  font-size: 17px;
  margin-right: 7px;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,wCAAwC;EACxC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,mCAAmC;EACnC,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,oCAAoC;AACtC;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;EAGE,eAAe;EACf,YAAY;EACZ,yBAAyB;EAIzB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EAGzB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EAEE,0BAA0B;EAE1B,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EAEE,uBAAuB;AACzB;;AAYA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;;AAGA;EACE,oCAAoC;AACtC;;;AAGA;EACE,UAAU;EACV,8BAA8B;AAChC;;AAEA;EAEE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;;EAEjB,eAAe;EACf,UAAU;EACV,mCAAmC;EAEnC,gCAAgC;AAClC;;AAEA;EAGE,0BAA0B;AAC5B;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kCAAkC;EAClC,4BAA4B;EAC5B,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;;;GAGG;;AAEH;EACE,2BAA2B;GAC1B,WAAW;IACV,yBAAyB;AAC7B;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;;EAEX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;;AAElB;AACA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA,aAAa,eAAe,CAAC,aAAa,CAAC,mBAAmB,CAAC;;AAE/D;EACE,eAAe;EACf,iBAAiB;AACnB","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\nbody {\n  background-color: black;\n}\n\n.banner-carousel {\n  background: black;\n}\n\n.search-text {\n  font-size: 16px;\n  margin: 0px 8px 0px -1px;\n  padding: 0px 13px;\n  border-radius: 50px;\n  color: grey;\n}\n\n.flaticon-search {\n  color: white;\n}\n\n.error-msg {\n  color: white;\n}\n\n.input-msg {\n  display: inline-grid;\n  font-size: 16px;\n}\n\n.inner-border {\n  border-style: dashed;\n  padding: 20px;\n  border-color: #fff;\n}\n\n.owl-carousel {\n  width: 100%;\n  -webkit-tap-highlight-color: transparent;\n  position: relative;\n  z-index: 1;\n}\n\n.owl-carousel .owl-stage {\n  position: relative;\n  -ms-touch-action: pan-Y;\n}\n\n.owl-carousel .owl-stage:after {\n  content: \".\";\n  display: block;\n  clear: both;\n  visibility: hidden;\n  line-height: 0;\n  height: 0;\n}\n\n.owl-carousel .owl-stage-outer {\n  position: relative;\n  overflow: hidden;\n  -webkit-transform: translate3d(0px, 0px, 0px);\n}\n\n.owl-carousel .owl-item {\n  position: relative;\n  min-height: 1px;\n  float: left;\n  -webkit-backface-visibility: hidden;\n  -webkit-tap-highlight-color: transparent;\n  -webkit-touch-callout: none;\n}\n\n.owl-carousel .owl-item img {\n  display: block;\n  width: 100%;\n  -webkit-transform-style: preserve-3d;\n}\n\n.owl-carousel .owl-nav.disabled,\n.owl-carousel .owl-dots.disabled {\n  display: none;\n}\n\n.owl-carousel .owl-nav .owl-prev,\n.owl-carousel .owl-nav .owl-next,\n.owl-carousel .owl-dot {\n  cursor: pointer;\n  cursor: hand;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.owl-carousel.owl-loaded {\n  display: block;\n}\n\n.owl-carousel.owl-loading {\n  opacity: 0;\n  display: block;\n}\n\n.owl-carousel.owl-hidden {\n  opacity: 0;\n}\n\n.owl-carousel.owl-refresh .owl-item {\n  visibility: hidden;\n}\n\n.owl-carousel.owl-drag .owl-item {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.owl-carousel.owl-grab {\n  cursor: move;\n  cursor: grab;\n}\n\n.owl-carousel.owl-rtl {\n  direction: rtl;\n}\n\n.owl-carousel.owl-rtl .owl-item {\n  float: right;\n}\n\n.no-js .owl-carousel {\n  display: block;\n}\n\n.owl-carousel .animated {\n  -webkit-animation-duration: 1000ms;\n  animation-duration: 1000ms;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n.owl-carousel .owl-animated-in {\n  z-index: 0;\n}\n\n.owl-carousel .owl-animated-out {\n  z-index: 1;\n}\n\n.owl-carousel .fadeOut {\n  -webkit-animation-name: fadeOut;\n  animation-name: fadeOut;\n}\n\n@-webkit-keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n}\n\n@keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n}\n\n\n.owl-height {\n  transition: height 500ms ease-in-out;\n}\n\n\n.owl-carousel .owl-item .owl-lazy {\n  opacity: 0;\n  transition: opacity 400ms ease;\n}\n\n.owl-carousel .owl-item img.owl-lazy {\n  -webkit-transform-style: preserve-3d;\n  transform-style: preserve-3d;\n}\n\n.owl-carousel .owl-video-wrapper {\n  position: relative;\n  height: 100%;\n  background: #000;\n}\n\n.owl-carousel .owl-video-play-icon {\n  position: absolute;\n  height: 80px;\n  width: 80px;\n  left: 50%;\n  top: 50%;\n  margin-left: -40px;\n  margin-top: -40px;\n\n  cursor: pointer;\n  z-index: 1;\n  -webkit-backface-visibility: hidden;\n  transition: -webkit-transform 100ms ease;\n  transition: transform 100ms ease;\n}\n\n.owl-carousel .owl-video-play-icon:hover {\n  -webkit-transform: scale(1.3, 1.3);\n  -ms-transform: scale(1.3, 1.3);\n  transform: scale(1.3, 1.3);\n}\n\n.owl-carousel .owl-video-playing .owl-video-tn,\n.owl-carousel .owl-video-playing .owl-video-play-icon {\n  display: none;\n}\n\n.owl-carousel .owl-video-tn {\n  opacity: 0;\n  height: 100%;\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-size: contain;\n  transition: opacity 400ms ease;\n}\n\n.owl-carousel .owl-video-frame {\n  position: relative;\n  z-index: 1;\n  height: 100%;\n  width: 100%;\n}\n\n.previous,.next {\n  background: #800925;\n  color: #ffff;\n  padding: 6px 6px;\n  border-radius: 5px;\n  width: 40px;\n}\np.card-text {\n  display: flex;\n  flex-direction: column;\n}\n\ndiv.info-profile-one input::placeholder{\n  color: #777777;\n}\n\ndiv.info-profile-one ul li{\n  color: black;\n}\n\n/* div.edit-profile-data ul li input{\n  border: 1px solid #00000042;\n  padding: 2px 2px 0px 10px;\n} */\n\ndiv.edit-partner-data input{\n  border: 1px solid #00000042;\n   width: 100%;\n    padding: 2px 2px 0px 10px;\n}\n.edit-profile-data select {\n  border: 1px solid #00000042;\n  max-width: 284px;\n  width: 100%;\n \n  background: none;\n}\n.profile-edit-two li, .profile-data-two li{\n  display: flex;\n  flex-direction: column;\n}\n.profile-edit-two input, .profile-edit-two select{\n  border: 2px solid #00000042;\n  padding: 0px 3px;\n  margin-left: 4px;\n  border-radius: 5px;\n}\n.profile-data-two input{\n  padding: 0px 3px;\n  margin-left: 4px;\n  border-radius: 5px;\n}\n.profile-edit-two label , .profile-data-two label{\n  font-size: 15px;\n  text-transform: capitalize;\n  font-weight: 500;\n\n}\n.profile-page-input label{\n  font-size: 15px;\n  text-transform: capitalize;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.profile-page-input input{\n  border: 2px solid #00000042;\n  padding: 0px 3px;\n  margin-left: 4px;\n  border-radius: 5px;\n}\n.info-profile-data .profile-page-input input{\n  padding: 0px 3px;\n  margin-left: 4px;\n  border-radius: 5px;\n  border: none;\n}\n.info-height {\n  min-height: 425px;\n}\n.ifo-bg {\n  background: #800925;\n  padding: 8px 12px;\n  border-radius: 10px;\n}\n.ifo-bg  i {\n  color: #fff;\n}\n.unread-msg{\n  margin-left: 80px;\n  border-radius: 50%;\n  border: 1px solid gray;\n  padding: 0px 5px;\n  background-color: #00000033;\n  color: white;\n}\n\n.backBtn {\n  display: flex;\n  align-items: center;\n  padding: 12px;\n}\n\n.backBtn h5 {font-size: 15px;display: flex;align-items: center;}\n\n.backBtn h5 svg {\n  font-size: 17px;\n  margin-right: 7px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
